import { inputFields, tables, Buttons } from "../../components";

const Scholarships = ({ state, setState, setActiveTab }) => {
  const handleScholarshipChange = (index, field, value) => {
    const updatedScholarships = [...state.scholarships];
    updatedScholarships[index][field] = value;
    setState({ ...state, scholarships: updatedScholarships });
  };

  const addScholarship = () => {
    const newScholarship = {
      title: "",
      link: "",
      entryType: "",
      awardType: "",
      tuitionCoverage: "",
      accommodationCoverage: "",
      academicReq: "",
      additionalReq: "",
    };
    setState({
      ...state,
      scholarships: [...state.scholarships, newScholarship],
    });
  };

  const removeScholarship = (index) => {
    const updatedScholarships = state.scholarships.filter(
      (_, i) => i !== index
    );
    setState({ ...state, scholarships: updatedScholarships });
  };

  const columns = [
    {
      title: "#",
      dataIndex: "#",
      width: 40,
      render: (text, record, index) => index + 1,
    },
    {
      title: "Title",
      dataIndex: "title",
      width: 180,
      render: (text, record, index) => (
        <inputFields.DefaultInput
          value={text}
          onChange={(e) =>
            handleScholarshipChange(index, "title", e.target.value)
          }
        />
      ),
    },
    {
      title: "Link",
      dataIndex: "link",
      width: 180,
      render: (text, record, index) => (
        <inputFields.DefaultInput
          value={text}
          onChange={(e) =>
            handleScholarshipChange(index, "link", e.target.value)
          }
        />
      ),
    },
    {
      title: "Entry type",
      dataIndex: "entryType",
      width: 200,
      render: (text, record, index) => (
        <inputFields.DefaultInput
          value={text}
          onChange={(e) =>
            handleScholarshipChange(index, "entryType", e.target.value)
          }
        />
      ),
    },
    {
      title: "Award type",
      dataIndex: "awardType",
      width: 180,
      render: (text, record, index) => (
        <inputFields.DefaultInput
          value={text}
          onChange={(e) =>
            handleScholarshipChange(index, "awardType", e.target.value)
          }
        />
      ),
    },
    {
      title: "Tution coverage",
      dataIndex: "tuitionCoverage",
      width: 180,
      render: (text, record, index) => (
        <inputFields.DefaultInput
          value={text}
          onChange={(e) =>
            handleScholarshipChange(index, "tuitionCoverage", e.target.value)
          }
        />
      ),
    },
    {
      title: "Accommodation coverage",
      dataIndex: "accommodationCoverage",
      width: 150,
      render: (text, record, index) => (
        <inputFields.DefaultInput
          value={text}
          onChange={(e) =>
            handleScholarshipChange(
              index,
              "accommodationCoverage",
              e.target.value
            )
          }
        />
      ),
    },
    {
      title: "Academic requirements",
      dataIndex: "academicReq",
      width: 300,
      render: (text, record, index) => (
        <inputFields.DefaultTextbox
          value={text}
          onChange={(e) =>
            handleScholarshipChange(index, "academicReq", e.target.value)
          }
        />
      ),
    },
    {
      title: "Additional requirements",
      dataIndex: "additionalReq",
      width: 300,
      render: (text, record, index) => (
        <inputFields.DefaultTextbox
          value={text}
          onChange={(e) =>
            handleScholarshipChange(index, "additionalReq", e.target.value)
          }
        />
      ),
    },
    {
      title: "Actions",
      width: 80,
      render: (_, record, index) => (
        <div>
          <Buttons.RedButton
            size="medium"
            onClick={() => removeScholarship(index)}
          >
            Remove
          </Buttons.RedButton>
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      <div className="w-[calc(100vw-20em)] overflow-x-auto max-w-full relative">
        <tables.DefaultTable
          dataSource={state.scholarships}
          columns={columns}
          rowKey={(record, index) => index}
          pagination={false}
        />
      </div>
      <div className="flex gap-5 justify-end">
        <Buttons.DefaultButton size="medium" onClick={addScholarship}>
          Add Scholarship
        </Buttons.DefaultButton>

        <Buttons.DefaultButton size="medium" onClick={() => setActiveTab("5")}>
          Next
        </Buttons.DefaultButton>
      </div>
    </div>
  );
};

export default Scholarships;
